export const PACK_STATUSES = [
  "Draft",
  "Created",
  "Checked",
  "Published",
  "In Use",
  "Returned",
  "Cancelled",
  "Rejected",
  "Void",
];

const packStatusTypes = {
  Draft: "draft",
  Created: "created",
  Checked: "checked",
  Published: "published",
  "In Use": "in-use",
  Returned: "returned",
  Cancelled: "cancelled",
  Rejected: "rejected",
  Void: "void",
};

export const getPackStatusType = (status) => packStatusTypes[status] || "secondary";
